// client/src/pages/bank-statements/BankStatements.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import BankStatementNav from '../../components/BankStatementNav';

function BankStatements() {
  return (
    <div>
      <BankStatementNav />
      <Outlet />
    </div>
  );
}

export default BankStatements;
